import React from 'react';
import LegalPageTemplate from '../../components/legal/LegalPageTemplate';

const LegalPage: React.FC = () => {
  return <LegalPageTemplate sectionKey="legal" />;
};

export default LegalPage;